import React from 'react';
import ProductCard from '../ProductCard';

const img = (key, fallback) =>
  (window.foxQuoteFormImages && window.foxQuoteFormImages[key]) || fallback;

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

const RoofTypeStep = ({ onSelect, selectedRoof }) => {
  const roofTypes = [
    {
      id: 'glass',
      title: 'Glass Roof',
      image: img('conservatory_roof_type_glass', `${BASE_URL}/extension/types/glass.jpeg`),
    },
    {
      id: 'flat',
      title: 'Flat Roof',
      image: img('conservatory_roof_type_flat', `${BASE_URL}/extension/types/flat.jpeg`),
    },
    {
      id: 'tiled-solid',
      title: 'Tiled Solid Roof',
      image: img('conservatory_roof_type_tiled_solid', `${BASE_URL}/conservatories/roof-types/tiled-solid.jpg`),
    },
    {
      id: 'solid',
      title: 'Solid Roof',
      image: img('conservatory_roof_type_solid', `${BASE_URL}/conservatories/roof-types/solid.jpg`),
    },
  ];

  return (
    <div className="w-full">
      {/* Title */}
      <h2 className="mb-12 text-center text-[24px] font-bold text-black">
        Choose Your Roof Type
      </h2>

      {/* Roof Type Grid - 2x2 with larger cards */}
      <div className="mx-auto grid max-w-[1240px] grid-cols-1 gap-6 px-4 sm:grid-cols-2">
        {roofTypes.map((roof) => (
          <ProductCard
            key={roof.id}
            image={roof.image}
            title={roof.title}
            isSelected={selectedRoof === roof.id}
            onClick={() => onSelect(roof.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default RoofTypeStep;
